import { createSlice } from '@reduxjs/toolkit';

export const salSlice = createSlice({
    name: 'sal',
    initialState: {
        items: [],
        isLoading: true,
    },
    reducers: {
        setItems: (state, action) => {
            state.items = action.payload;
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const { setItems, setIsLoading } = salSlice.actions;

export default salSlice.reducer;
